import { SkeletonLoader } from '@toggle/design-system';
import React from 'react';

import * as S from './LoaderCell.styles';

export const LoaderCell = ({ columnLength }: { columnLength: number }) => {
  return (
    <>
      {Array.from({ length: 3 }).map((_, index) => {
        return (
          <tr key={`tr-${index}`}>
            {Array.from({ length: columnLength }).map((_, index) => {
              return (
                <S.StyledTableCell key={index}>
                  <SkeletonLoader
                    areas={[
                      {
                        styles: {
                          width: '100%',
                          height: '20px',
                          borderRadius: '8px',
                        },
                      },
                    ]}
                  />
                </S.StyledTableCell>
              );
            })}
          </tr>
        );
      })}
    </>
  );
};
